import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { IFilterOption } from "@faire/web-api--source/indigofair/data/IFilterOption";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
export var SEE_MORE_THRESHOLD = 3;
export var SEE_MORE_STEP = 10;
var DEFAULT_SHOW_ALL_FILTER_SECTIONS = [
    IFilterSection.FieldName.ORDER_STATUS
];
var bringToggleFilterToFront = function(a, b) {
    if (a.selection_type === IFilterSection.SelectionType.TOGGLE && b.selection_type !== IFilterSection.SelectionType.TOGGLE) {
        return -1;
    }
    return 0;
};
export var getSortedFilterSections = function(filterSections, includeSortSection) {
    if (includeSortSection) {
        return _to_consumable_array(filterSections).filter(function(filterSection) {
            return filterSection.selection_type !== IFilterSection.SelectionType.MULTIPLE_OPTIONAL_SELECTIONS;
        }).sort(bringToggleFilterToFront);
    }
    return filterSections.filter(function(filterSection) {
        return filterSection.field_function !== IFilterSection.FieldFunction.SORT && filterSection.selection_type !== IFilterSection.SelectionType.MULTIPLE_OPTIONAL_SELECTIONS;
    }).sort(bringToggleFilterToFront);
};
export var getToggleFilters = function(filterSections) {
    return filterSections.filter(function(filterSection) {
        return filterSection.selection_type === IFilterSection.SelectionType.TOGGLE;
    });
};
export var getMultipleOptionalSelectionsFilters = function(filterSections) {
    return filterSections.filter(function(filterSection) {
        return filterSection.selection_type === IFilterSection.SelectionType.MULTIPLE_OPTIONAL_SELECTIONS;
    });
};
var recursivelySyncMultipleOptionalSelectionsFilters = function(option, multipleOptionalSelectionsFilters) {
    multipleOptionalSelectionsFilters.forEach(function(m_section) {
        m_section.options.forEach(function(m_option) {
            if (m_option.key === option.key) {
                m_option.is_selected = option.is_selected;
            }
        });
    });
    option.sub_options.forEach(function(subOption) {
        recursivelySyncMultipleOptionalSelectionsFilters(subOption, multipleOptionalSelectionsFilters);
    });
};
export var syncToggleFilters = function(section, filterSections) {
    var toggleFilterSections = getToggleFilters(filterSections);
    var multipleOptionalSelectionsFilters = getMultipleOptionalSelectionsFilters(filterSections);
    section.options.forEach(function(option) {
        recursivelySyncToggleFilters(option, toggleFilterSections);
        recursivelySyncMultipleOptionalSelectionsFilters(option, multipleOptionalSelectionsFilters);
    });
};
var recursivelySyncToggleFilters = function(option, toggleFilterSections) {
    toggleFilterSections.forEach(function(section) {
        var firstOption = section.options.length > 0 ? section.options[0] : undefined;
        if (firstOption && firstOption.key === option.key) {
            firstOption.is_selected = option.is_selected;
        }
    });
    option.sub_options.forEach(function(subOption) {
        recursivelySyncToggleFilters(subOption, toggleFilterSections);
    });
};
export var updateAllFilterKeys = function(filterSections, filterKey, value) {
    filterSections.forEach(function(section) {
        section.options.forEach(function(option) {
            recursivelyToggleFilter(option, filterKey, value);
        });
    });
    return filterSections;
};
export var DEFAULT_OPTION_GROUP_NAME = "default_option_group";
export var getFilteredOptionsGroupMap = function(filterSection, searchValue, optionsLimit) {
    var optionsGroupMap = _define_property({}, DEFAULT_OPTION_GROUP_NAME, []);
    var filteredOptions = filterSection.options.filter(function(option) {
        if (searchValue === "" || matchesSearchValue(option, searchValue)) {
            return true;
        }
        return false;
    });
    filteredOptions.slice(0, optionsLimit).forEach(function(option) {
        var group = filterSection.option_groups.find(function(optionGroup) {
            return optionGroup.key === option.group_key;
        });
        var _group_display_name;
        var groupName = (_group_display_name = group === null || group === void 0 ? void 0 : group.display_name) !== null && _group_display_name !== void 0 ? _group_display_name : DEFAULT_OPTION_GROUP_NAME;
        var _optionsGroupMap_groupName;
        var options = (_optionsGroupMap_groupName = optionsGroupMap[groupName]) !== null && _optionsGroupMap_groupName !== void 0 ? _optionsGroupMap_groupName : [];
        options.push(option);
        optionsGroupMap[groupName] = options;
    });
    return {
        optionsGroupMap: optionsGroupMap,
        totalFilteredOptions: filteredOptions.length
    };
};
export var getFilterSection = function(options, fieldNameToGet) {
    return options.find(function(option) {
        return option.field_name === fieldNameToGet;
    });
};
export var getFilteredOptions = function(options, searchValue) {
    if (searchValue === "") {
        return options;
    }
    return options.filter(function(option) {
        return matchesSearchValue(option, searchValue);
    });
};
var matchesSearchValue = function(option, searchValue) {
    var _option_display_name;
    var optionMatches = (_option_display_name = option.display_name) === null || _option_display_name === void 0 ? void 0 : _option_display_name.toLowerCase().includes(searchValue.toLowerCase());
    return optionMatches || option.sub_options.some(function(option) {
        return matchesSearchValue(option, searchValue);
    });
};
export var isDefaultShowAllFilterSection = function(filterSection) {
    var _filterSection_field_name;
    return DEFAULT_SHOW_ALL_FILTER_SECTIONS.includes(IFilterSection.FieldName[(_filterSection_field_name = filterSection.field_name) !== null && _filterSection_field_name !== void 0 ? _filterSection_field_name : "FIELD_NAME_UNKNOWN"]);
};
export var hasSelectedOptions = function(filterOption) {
    var _filterOption_sub_options;
    return !!(filterOption === null || filterOption === void 0 ? void 0 : filterOption.is_selected) || !!(filterOption === null || filterOption === void 0 ? void 0 : (_filterOption_sub_options = filterOption.sub_options) === null || _filterOption_sub_options === void 0 ? void 0 : _filterOption_sub_options.some(hasSelectedOptions));
};
export var clearAllFilters = function(filterSections) {
    filterSections.forEach(function(section) {
        clearFilterSection(section);
    });
};
export var clearFilterSection = function(filterSection) {
    filterSection.options.forEach(function(option) {
        recursivelyClearFilter(option);
    });
};
export var recursivelyClearFilter = function(filterOption, filterKey) {
    var _filterOption_sub_options;
    (_filterOption_sub_options = filterOption.sub_options) === null || _filterOption_sub_options === void 0 ? void 0 : _filterOption_sub_options.forEach(function(subOption) {
        recursivelyClearFilter(subOption, filterKey);
    });
    if (filterOption.key !== filterKey) {
        filterOption.is_selected = false;
        filterOption.selection_state = IFilterOption.SelectionState.UNSELECTED;
    }
};
export var recursivelyToggleFilter = function(filterOption, filterKey, value) {
    var _filterOption_sub_options;
    (_filterOption_sub_options = filterOption.sub_options) === null || _filterOption_sub_options === void 0 ? void 0 : _filterOption_sub_options.forEach(function(subOption) {
        recursivelyToggleFilter(subOption, filterKey, value);
    });
    if (filterOption.key === filterKey) {
        filterOption.is_selected = value;
    }
};
export var updateAllSelectableSubOptions = function(filterOption) {
    if (!filterOption) {
        return;
    }
    selectableSubOptionsOf(filterOption).forEach(function(subOption) {
        subOption.is_selected = filterOption.is_selected;
        updateAllSelectableSubOptions(subOption);
    });
};
var selectableSubOptionsOf = function(filterOption) {
    var _filterOption_sub_options;
    var _filterOption_sub_options_filter;
    return (_filterOption_sub_options_filter = (_filterOption_sub_options = filterOption.sub_options) === null || _filterOption_sub_options === void 0 ? void 0 : _filterOption_sub_options.filter(function(subOption) {
        var _subOption_results_count;
        return ((_subOption_results_count = subOption.results_count) !== null && _subOption_results_count !== void 0 ? _subOption_results_count : 0) > 0 || subOption.is_selected;
    })) !== null && _filterOption_sub_options_filter !== void 0 ? _filterOption_sub_options_filter : [];
};
export var selectIfSelectedAllSubOptions = function(filterOption) {
    if (!filterOption) {
        return;
    }
    var selectableSubOptions = selectableSubOptionsOf(filterOption);
    if (selectableSubOptions.length > 0) {
        selectableSubOptions.forEach(selectIfSelectedAllSubOptions);
        filterOption.is_selected = selectableSubOptions.every(function(subOption) {
            return !!subOption.is_selected;
        });
    }
};
export var getSelectedOptions = function(filterSection) {
    return filterSection.options.flatMap(recursivelyGetSelectedOptions);
};
var recursivelyGetSelectedOptions = function(option) {
    var selectedOptions = [];
    if (option.is_selected) {
        selectedOptions.push(option);
    }
    return selectedOptions.concat(option.sub_options.flatMap(recursivelyGetSelectedOptions));
};
export var getSelectedFiltersCount = function(filterSections) {
    var count = 0;
    filterSections.filter(function(section) {
        return section.selection_type !== IFilterSection.SelectionType.MULTIPLE_OPTIONAL_SELECTIONS && section.field_function !== IFilterSection.FieldFunction.SORT;
    }).forEach(function(section) {
        section.options.forEach(function(option) {
            count += recursivelyGetSelectedFiltersCount(option);
        });
    });
    return count;
};
var recursivelyGetSelectedFiltersCount = function(option) {
    if (option.sub_options.length === 0) {
        return option.selection_state === IFilterOption.SelectionState.FULLY_SELECTED || option.is_selected ? 1 : 0;
    }
    return option.sub_options.reduce(function(count, subOption) {
        return count + recursivelyGetSelectedFiltersCount(subOption);
    }, 0);
};
export var getFirstFilterSectionsWithTooltip = function(filterSections) {
    var section;
    filterSections.every(function(filterSection) {
        if (filterSection.tooltip !== undefined) {
            section = filterSection;
            return false;
        }
        return true;
    });
    return section;
};
